import { Skeleton } from '@mui/material';
import styled from 'styled-components';

const SkeletonTable = () => {
    return (
        <SkeletonWrapper>
            <Skeleton
                animation="wave"
                variant="rectangular"
                width="100%"
                height={60}
            />
            <Skeleton animation="wave" variant="text" height={50} />
            <Skeleton animation="wave" variant="text" height={50} />
            <Skeleton animation="wave" variant="text" height={50} />
        </SkeletonWrapper>
    );
};

export default SkeletonTable;

const SkeletonWrapper = styled.div`
    padding: 1rem;
    border-radius: 1rem;

    div {
        border-radius: 1rem;
    }
`;
